import consumer from "./consumer"

export function subscribeToConversation(conversationId, onMessage) {
  return consumer.subscriptions.create(
    { channel: "ConversationChannel", conversation_id: conversationId },
    {
      received(data) {
        if (data.type === 'new_message') {
          onMessage(data.message)
        }
      }
    }
  )
}
